<template>
  <div>
    <div class="accordion-holder" @click="toggleOpen()">
      <div :class="{'accordion' : true, 'active' : opened }" v-html="heading" />
    </div>
    <div v-show="opened" class="panel">
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    heading: {
      type: String,
      required: false,
      default: '',
    },
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    locked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      opened: true,
    };
  },
  created() {
    this.opened = this.open;
  },

  methods: {
    toggleOpen() {
      if (this.locked === false) this.opened = !this.opened;
      this.$emit('changed', this.opened);
    },
    openAccordion() {
      this.opened = true;
      this.$emit('changed', this.opened);
    },
    close() {
      if (this.opened) {
        this.opened = false;
        this.$emit('changed', this.opened);
      }
    },
  },
};

</script>

  <style lang="scss" scoped>
  @import "../assets/styles/settings/config.scss";

  .accordion-holder{
    cursor: pointer;
  }

  .accordion {
    position: relative;
    border-bottom: solid 1px $darkCement;
    background-color:$white;
    color: $darkBlack;
    cursor: pointer;
    min-height: 47px;
    padding: 0 .5em;
    width: 100%;
    border: none;
    outline: none;
    transition: 0.4s;
    display: flex;
    justify-content: space-between;
    align-items: center;

    // font styling
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 500;
  }

   .accordion:after {
    @include triangle(6px, $darkBlack, down);
    float: right;
  }

  .active:after {
    @include triangle(6px, $darkBlack, up);
  }

  /* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
  .accordion:hover {
    background-color: lighten($ionianPale, 2%);
  }

  /* Style the accordion panel. Note: hidden by default with JS */
  .panel {
    background-color: $white;
    display: block;
    overflow: hidden;
    margin: 0 5px;
    position: relative;
  }
</style>
